const differenceSecs = (start: any, finish: any) => {
  let millSeconds = Math.abs(finish.getTime() - start.getTime()) / 1000;
  return millSeconds;
};

const timeLap = (timein: any, timeout: any) => {
  let out = timeout === null ? new Date() : timeout;
  let totalMillSeconds: any = differenceSecs(new Date(timein), new Date(out));

  const days = Math.floor(totalMillSeconds / 86400);
  totalMillSeconds -= days * 86400;

  const hours = Math.floor(totalMillSeconds / 3600) % 24;
  totalMillSeconds -= hours * 3600;

  const minutes = Math.floor(totalMillSeconds / 60) % 60;
  totalMillSeconds -= minutes * 60;

  const seconds = Math.floor(totalMillSeconds / 1) % 60;
  totalMillSeconds -= seconds * 60;

  let difference = "";
  if (days > 0) {
    difference += days === 1 ? `${days} day ` : `${days} days `;
  }

  if (hours > 0) {
    difference += hours === 0 || hours === 1 ? `${hours} hr ` : `${hours} hrs `;
  }

  if (minutes > 0) {
    difference +=
      minutes === 0 || hours === 1 ? `${minutes} min ` : `${minutes} mins `;
  }

  difference +=
    seconds === 0 || minutes === 1 ? `${seconds} sec ` : `${seconds} secs `;

  let result = difference;

  return result;
};

export { timeLap };
